import type * as React from 'react';
import type { DuplicateImageProps } from './types';

export const DuplicateImage: React.FC<DuplicateImageProps> = ({
    children,
}: DuplicateImageProps) => {
    // TODO Add implementation if it's needed
    return children;
};
